import React from 'react';
import Icon from '../../../components/AppIcon';


const FeaturesSection = () => {
  const features = [
    {
      icon: 'BarChart3',
      title: 'Transaction Tracking & Smart Categorization',
      description: 'Automatically organize your spending into clear categories. See where every dollar goes without manual work.',
      color: 'primary'
    },
    {
      icon: 'Wallet',
      title: 'Multi-Account Management',
      description: 'Track checking, savings, credit cards, and more—all in one dashboard. No more switching between apps.',
      color: 'accent'
    },
    {
      icon: 'Upload',
      title: 'CSV Import for Fast Setup',
      description: 'Import your bank statements instantly. Get up and running in minutes, not hours.',
      color: 'success'
    },
    {
      icon: 'Bell',
      title: 'Budget Alerts & Notifications',
      description: 'Stay informed with smart alerts when you approach budget limits or unusual spending is detected.',
      color: 'warning'
    },
    {
      icon: 'Calendar',
      title: 'Payment Calendar & Reminders',
      description: 'Never miss a bill. Visual calendar shows all upcoming payments so you can plan ahead.',
      color: 'secondary'
    },
    {
      icon: 'PieChart',
      title: 'Financial Insights & Spending Breakdowns',
      description: 'Understand your money with clear charts and insights. Make smarter decisions based on real data.',
      color: 'primary'
    },
    {
      icon: 'RefreshCw',
      title: 'Account Reconciliation',
      description: 'Keep your records accurate. Easily match your tracked balance with actual bank statements.',
      color: 'accent'
    },
    {
      icon: 'Lock',
      title: 'Strong Data Security & Privacy',
      description: 'Bank-level encryption protects your information. Your data is never sold or shared with third parties.',
      color: 'success'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      primary: 'bg-primary/10 text-primary',
      accent: 'bg-accent/10 text-accent',
      success: 'bg-success/10 text-success',
      warning: 'bg-warning/10 text-warning',
      secondary: 'bg-secondary/10 text-secondary'
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-primary/5 via-background to-accent/5">
      <div className="mx-auto px-4 md:px-6 lg:px-24 max-w-7xl">
        <div className="text-center mb-10 md:mb-14 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-secondary mb-3 md:mb-4">
            Everything You Need to Manage Your Money
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            Powerful features that work together to give you complete financial clarity
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features?.map((feature, index) => (
            <div
              key={index}
              className="bg-card rounded-xl md:rounded-2xl shadow-elevation-2 hover:shadow-elevation-3 transition-smooth p-5 md:p-6"
            >
              <div className={`inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-xl ${getColorClasses(feature?.color)} mb-4`}>
                <Icon name={feature?.icon} size={24} strokeWidth={2} />
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-card-foreground mb-2 md:mb-3">
                {feature?.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;